import { createReducer, createAction } from '@reduxjs/toolkit'

interface SetColumnNumberPayload {
  columns: number
}
export const SET_COLUMN_NUMBER = createAction<SetColumnNumberPayload>('list_layout_reducer/set_column_number')

export type RenderedComponent = 'BrowseItem'
export interface ListLayoutReducer {
  columns: number
  compensationPadding: number
  width: number
  space: number
  renderedComponent: RenderedComponent
  offerId: number | null
  offerOpened: boolean
}

const initialState: ListLayoutReducer = {
  columns: 3,
  compensationPadding: 10,
  width: 1050,
  space: 4,
  renderedComponent: 'BrowseItem',
  offerId: null,
  offerOpened: false
}

interface SwitchGridRenderedItemPayload {
  renderedComponent: RenderedComponent
  columns: number
}
export const SWITCH_GRID_RENDERED_ITEM = createAction<SwitchGridRenderedItemPayload>('list_layout_reducer/switch_grid')

interface OpenOfferPayload {
  offerId: number
}
export const OPEN_OFFER = createAction<OpenOfferPayload>('list_layout_reducer/open_offer')
export const CLOSE_OFFER = createAction('list_layout_reducer/close_offer')

export const listLayoutReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(SWITCH_GRID_RENDERED_ITEM, (state, action) => {
      return { ...state, renderedComponent: action.payload.renderedComponent, columns: action.payload.columns }
    })
    .addCase(SET_COLUMN_NUMBER, (state, action) => {
      return { ...state, columns: action.payload.columns }
    })
    .addCase(OPEN_OFFER, (state, action) => {
      return { ...state, offerId: action.payload.offerId, offerOpened: true }
    })
    .addCase(CLOSE_OFFER, (state) => {
      return { ...state, offerId: null, offerOpened: false }
    })
})
